const state = () => ({
  count: 0
});

const getters = {
  getCount: (state) => {
    return state.count;
  }
};

const mutations = {
  setCount: (state, value) => {
    state.count = value;
  }
};

const actions = {
  updateCount({ commit }, value) {
    commit('setCount', value);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
